import { Easing, Animated } from 'react-native';

import SignInScreen from './SignInScreen';
import IntroScreen from './IntroScreen';
import InnerContainer from './InnerContainer';
import CombatScreen from './Combat/CombatScreen';
import { IS_WEB } from '../lib/appConstants';
import StackNavigator from '../lib/StackNavigator';

const stackNavigatorConfig = {
  initialRouteName: 'SignIn',
  headerMode: 'none',
  cardStyle: { backgroundColor: 'transparent', shadowOpacity: 0 },
  ...(IS_WEB
    ? {
        transitionConfig: () => ({
          transitionSpec: {
            duration: 0,
            timing: Animated.timing,
            easing: Easing.step0,
          },
        }),
      }
    : null),
};

const Stack = StackNavigator(
  {
    SignIn: { screen: SignInScreen },
    Intro: { screen: IntroScreen },
    Inner: {
      screen: InnerContainer,
      navigationOptions: { gesturesEnabled: false },
    },
    Combat: {
      screen: CombatScreen,
      navigationOptions: { gesturesEnabled: false },
    },
  },
  stackNavigatorConfig,
);

export default Stack;
